






































import { defineComponent } from '@nuxtjs/composition-api';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
export default defineComponent({
  name: 'BaseRating',
  inject: {
    components: {
      default: { BaseIcon },
    },
  },
  props: {
    max: {
      type: Number,
      default: 5,
    },
    score: {
      type: Number,
      default: 1,
    },
    icon: {
      type: String,
      default: 'star',
    },
  },
  data(...args): any {
    return args;
  },
  // @ts-ignore migrated from ui-library
  finalScore(score, max) {
    return !score || score < 0 || (score > max && max > 0) || max <= 0 ? 0 : score;
  },
  // @ts-ignore migrated from ui-library
  finalMax(max) {
    return !max || max <= 0 ? 1 : max;
  },
});
